<template>
  <div class="products-page">
 <!-- 策略优势展示 -->
    <section class="strategy-advantages">
      <div class="content-wrapper">
        
        <p class="strategy-description">产品自运行以来，通过科学的量化模型与严格的风控体系，在不同市场环境下均展现出较强的竞争力。策略以多因子为基石，融合事件驱动、趋势追踪等多种方法，有效捕捉市场机会的同时控制风险，长期表现稳健，获得了合作方的认可。</p>
        <div class="diagram-wrapper">
          <div class="advantages-diagram">
          <!-- 中心核心 -->
          <div class="diagram-core">
            <div class="core-title">全天候投资策略</div>
            <div class="core-content">
              <div class="core-strategy">科学投资理念</div>
              <div class="core-strategy">持续稳健回报</div>
            </div>
          </div>

          <!-- 四个顶点优势 -->
          <div class="advantage-vertex high-growth">
            <div class="vertex-icon">
              <i class="fa fa-line-chart"></i>
            </div>
            <div class="vertex-title">多因子策略</div>
          </div>
          <div class="advantage-vertex low-volatility">
            <div class="vertex-icon">
              <i class="fa fa-shield"></i>
            </div>
            <div class="vertex-title">风险过滤</div>
          </div>
          <div class="advantage-vertex large-capacity">
            <div class="vertex-icon">
              <i class="fa fa-balance-scale"></i>
            </div>
            <div class="vertex-title">左侧反转</div>
          </div>
          <div class="advantage-vertex high-liquidity">
            <div class="vertex-icon">
              <i class="fa fa-exchange"></i>
            </div>
            <div class="vertex-title">事件驱动</div>
          </div>

          <!-- 周围优势点 -->
          <div class="advantage-point theoretical-practice">
            <div class="point-icon">
              <i class="fa fa-graduation-cap"></i>
            </div>
            <div class="point-content">
              <h3 class="point-title">投资标的选择</h3>
              <ul class="point-list">
                <li>聚焦A股和ETF市场</li>
                <li>多因子策略为基石</li>
                <li>多元化策略组合构建</li>
              </ul>
            </div>
          </div>

          <div class="advantage-point multi-strategy">
            <div class="point-icon">
              <i class="fa fa-cogs"></i>
            </div>
            <div class="point-content">
              <h3 class="point-title">多策略融合</h3>
              <ul class="point-list">
                <li>事件驱动策略</li>
                <li>趋势追踪策略</li>
                <li>风格轮动策略</li>
                <li>左侧反转交易</li>
              </ul>
            </div>
          </div>

          <div class="advantage-point portfolio-diversification">
            <div class="point-icon">
              <i class="fa fa-pie-chart"></i>
            </div>
            <div class="point-content">
              <h3 class="point-title">风险分散</h3>
              <ul class="point-list">
                <li>多策略组合降低风险</li>
                <li>有效分散单一因素冲击</li>
                <li>紧密交织的安全网</li>
              </ul>
            </div>
          </div>

          <div class="advantage-point balanced-risk">
            <div class="point-icon">
              <i class="fa fa-rocket"></i>
            </div>
            <div class="point-content">
              <h3 class="point-title">技术运用</h3>
              <ul class="point-list">
                <li>大模型技术</li>
                <li>大数据技术</li>
                <li>追踪市场热点</li>
                <li>把握投资契机</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 因子全生命周期管理 -->
    <section class="factor-lifecycle-section">
      <div class="content-wrapper">
        <p class="factor-intro">从监测到优化：因子的全流程管理，确保因子有效性与持续进化</p>
        
        <!-- 卡片式布局 -->
        <div class="factor-cards-container" style="display: grid !important; grid-template-columns: repeat(2, 1fr) !important; gap: 30px !important; margin-bottom: 80px !important; max-width: 1200px !important; margin-left: auto !important; margin-right: auto !important;">
          <!-- 监测卡片 -->
          <div class="factor-card monitor-card" style="display: flex; flex-direction: column; height: 100%;">
            <div class="card-header">
              <div class="card-icon">
                <i class="fa fa-line-chart"></i>
              </div>
              <h3 class="card-title">因子监测</h3>
            </div>
            <div class="card-content">
              <p class="card-desc">实时跟踪因子有效性（IC/IR指标）与衰减情况，及时发现因子性能变化</p>
              <div class="card-features">
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>IC/IR指标实时监控</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>因子衰减趋势分析</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>异常告警机制</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 诊断卡片 -->
          <div class="factor-card diagnose-card" style="display: flex; flex-direction: column; height: 100%;">
            <div class="card-header">
              <div class="card-icon">
                <i class="fa fa-search"></i>
              </div>
              <h3 class="card-title">因子诊断</h3>
            </div>
            <div class="card-content">
              <p class="card-desc">归因分析因子贡献度，识别失效因子，定位问题根源</p>
              <div class="card-features">
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>因子贡献度分析</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>失效因子识别</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>问题根源定位</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 优化卡片 -->
          <div class="factor-card optimize-card" style="display: flex; flex-direction: column; height: 100%;">
            <div class="card-header">
              <div class="card-icon">
                <i class="fa fa-cog"></i>
              </div>
              <h3 class="card-title">因子优化</h3>
            </div>
            <div class="card-content">
              <p class="card-desc">通过特征工程与模型迭代更新因子库，提升因子性能与适应性</p>
              <div class="card-features">
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>特征工程优化</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>模型迭代更新</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>因子库持续进化</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 风控卡片 -->
          <div class="factor-card risk-card" style="display: flex; flex-direction: column; height: 100%;">
            <div class="card-header">
              <div class="card-icon">
                <i class="fa fa-shield"></i>
              </div>
              <h3 class="card-title">因子风控</h3>
            </div>
            <div class="card-content">
              <p class="card-desc">控制单因子暴露上限，避免过度集中，降低系统性风险</p>
              <div class="card-features">
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>单因子暴露控制</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>风险集中度管理</span>
                </div>
                <div class="feature-item">
                  <i class="fa fa-check-circle"></i>
                  <span>系统性风险防控</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 管理闭环 -->
        <div class="cycle-section">
          <h3 class="cycle-title">全天候管理闭环</h3>
          <div class="cycle-content">
            <p>监测 → 诊断 → 优化 → 风控的持续循环，确保因子有效性与适应性</p>
            <div class="cycle-visual">
              <div class="cycle-circle">
                <div class="cycle-step step-1">
                  <div class="step-number">1</div>
                  <div class="step-name">监测</div>
                </div>
                <div class="cycle-step step-2">
                  <div class="step-number">2</div>
                  <div class="step-name">诊断</div>
                </div>
                <div class="cycle-step step-3">
                  <div class="step-number">3</div>
                  <div class="step-name">优化</div>
                </div>
                <div class="cycle-step step-4">
                  <div class="step-number">4</div>
                  <div class="step-name">风控</div>
                </div>
                <div class="cycle-arrow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
    };
  }
}
</script>

<style scoped>
.products-page {
  min-height: 100vh;
  padding-top: 90px; /* 74px header + 间距 */
  background: #f5f7fa;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 策略描述文字 */
.strategy-description {
  font-family: 'Roboto', 'Open Sans', 'Microsoft YaHei', 'PingFang SC', sans-serif;
  font-size: 17px;
  color: #546570;
  line-height: 1.8;
  margin: 10px auto 60px;
  max-width: 900px;
  text-align: center;
  padding: 0 20px;
  letter-spacing: 0.5px;
}

/* 策略优势展示 */
.strategy-advantages {
  background: #fff;
  padding: 80px 20px 100px;
  position: relative;
  overflow: hidden;
}

.strategy-advantages .section-title {
  margin-bottom: 20px;
}

.advantages-diagram {
  position: relative;
  max-width: 1200px;
  margin: 60px auto 0;
  min-height: 600px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 20px;
  align-items: center;
  justify-items: center;
}

/* 外层缩放容器：在移动端按比例缩放整个图表，不改变内部样式 */
.diagram-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  /* 保持占位，使页面流布局尽量不受影响 */
  width: 100%;
}

/* 使用 CSS 变量控制缩放比例，便于在 media query 中调整 */
:root {
  --diagram-scale: 1;
}

.diagram-wrapper .advantages-diagram {
  transform-origin: center center;
  transform: scale(var(--diagram-scale));
  transition: transform 200ms ease;
}

/* 小屏幕缩放：按比例缩小，不修改内部字体大小或布局规则 */
@media (max-width: 960px) {
  :root {
    --diagram-scale: 0.85;
  }
}

@media (max-width: 768px) {
  :root {
    --diagram-scale: 0.72;
  }
}

@media (max-width: 520px) {
  :root {
    --diagram-scale: 0.58;
  }
  /* 缩放后保持外层间距，防止被剪裁 */
  .diagram-wrapper {
    padding: 10px 6px 40px;
  }
}

/* 中心核心 */
.diagram-core {
  grid-column: 2;
  grid-row: 2;
  width: 220px;
  height: 220px;
  background: linear-gradient(135deg, #3d5fbf 0%, #2f54eb 100%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 10px 30px rgba(61, 95, 191, 0.4);
  z-index: 10;
}

.core-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  letter-spacing: 1px;
}

.core-content {
  text-align: center;
}

.core-strategy {
  font-size: 20px;
  font-weight: 600;
  margin: 8px 0;
}

/* 四个顶点优势 */
.advantage-vertex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 5;
}

.vertex-icon {
  width: 80px;
  height: 80px;
  background: #e6f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: #1890ff;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  transition: all 0.3s ease;
}

.vertex-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.3);
}

.vertex-title {
  font-size: 18px;
  font-weight: 600;
  color: #304156;
}

.high-growth {
  grid-column: 2;
  grid-row: 1;
}

.low-volatility {
  grid-column: 1;
  grid-row: 3;
}

.large-capacity {
  grid-column: 3;
  grid-row: 3;
}

.high-liquidity {
  grid-column: 3;
  grid-row: 1;
}

/* 周围优势点 */
.advantage-point {
  display: flex;
  align-items: flex-start;
  gap: 25px;
  max-width: 320px;
  z-index: 5;
  padding: 20px;
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.advantage-point:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.point-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #1890ff;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.25);
  flex-shrink: 0;
  transition: all 0.3s ease;
  border: 2px solid #b3d8ff;
}

.point-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.3);
}

.point-content {
  flex: 1;
}

.point-title {
  font-size: 18px;
  font-weight: 600;
  color: #304156;
  margin: 0 0 15px;
  line-height: 1.3;
}

.point-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.point-list li {
  font-size: 14px;
  color: #606266;
  line-height: 1.7;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}

.point-list li::before {
  content: '•';
  position: absolute;
  left: 0;
  top: 2px;
  color: #1890ff;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.5;
}

.theoretical-practice {
  grid-column: 1;
  grid-row: 1;
  justify-self: start;
}

.multi-strategy {
  grid-column: 1;
  grid-row: 2;
  justify-self: start;
  align-self: start;
}

.portfolio-diversification {
  grid-column: 3;
  grid-row: 2;
  justify-self: end;
  align-self: start;
}

.balanced-risk {
  grid-column: 3;
  grid-row: 1;
  justify-self: end;
}

/* 连接线（可选） */
.advantages-diagram::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  border: 2px solid #e6f7ff;
  border-radius: 50%;
  pointer-events: none;
  opacity: 0.6;
}

/* 因子全生命周期管理 */
.factor-lifecycle-section {
  background: #fff;
  padding: 90px 20px;
  position: relative;
}

.factor-intro {
  text-align: center;
  font-size: 18px;
  color: #606266;
  margin: 20px auto 60px;
  max-width: 800px;
  line-height: 1.6;
}

/* 卡片式布局 */
.factor-cards-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 80px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.factor-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 2px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.factor-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);
  border-color: #1890ff;
}

/* 不同卡片的颜色主题 */
.monitor-card {
  border-top: 4px solid #1890ff;
}

.diagnose-card {
  border-top: 4px solid #f56c6c;
}

.optimize-card {
  border-top: 4px solid #e6a23c;
}

.risk-card {
  border-top: 4px solid #67c23a;
}

.card-header {
  padding: 30px 30px 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.monitor-card .card-icon {
  background: linear-gradient(135deg, #1890ff 0%, #409eff 100%);
}

.diagnose-card .card-icon {
  background: linear-gradient(135deg, #f56c6c 0%, #ff7875 100%);
}

.optimize-card .card-icon {
  background: linear-gradient(135deg, #e6a23c 0%, #ffa940 100%);
}

.risk-card .card-icon {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
}

.card-title {
  font-size: 22px;
  font-weight: 600;
  color: #304156;
  margin: 0;
}

.card-content {
  padding: 30px;
}

.card-desc {
  font-size: 15px;
  color: #606266;
  line-height: 1.6;
  margin: 0 0 20px;
}

.card-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #606266;
}

.feature-item i {
  color: #67c23a;
  font-size: 16px;
  flex-shrink: 0;
}

/* 管理闭环 */
.cycle-section {
  text-align: center;
  background: #f8f9fa;
  padding: 60px 20px;
  border-radius: 12px;
}

.cycle-title {
  font-size: 24px;
  font-weight: 600;
  color: #304156;
  margin: 0 0 30px;
}

.cycle-content p {
  font-size: 16px;
  color: #606266;
  margin: 0 0 40px;
  line-height: 1.6;
}

.cycle-visual {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.cycle-circle {
  position: relative;
  width: 350px;
  height: 350px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.cycle-circle:hover {
  transform: scale(1.02);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
}

.cycle-step {
  position: absolute;
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.cycle-step:hover {
  transform: scale(1.1);
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #1890ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.step-name {
  font-size: 16px;
  font-weight: 600;
  color: #304156;
}

.cycle-step.step-1 {
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.cycle-step.step-2 {
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.cycle-step.step-3 {
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.cycle-step.step-4 {
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
}

.cycle-arrow {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid #1890ff;
  border-radius: 50%;
  opacity: 0.3;
}

.cycle-arrow::before {
  content: '';
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 25px solid #1890ff;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .factor-cards-container {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 25px;
  }
  
  .advantages-diagram {
    min-height: 500px;
    gap: 20px;
  }
  
  .diagram-core {
    width: 180px;
    height: 180px;
  }
  
  .core-title {
    font-size: 14px;
  }
  
  .core-strategy {
    font-size: 16px;
  }
  
  .vertex-icon {
    width: 70px;
    height: 70px;
    font-size: 32px;
  }
  
  .vertex-title {
    font-size: 16px;
  }
  
  .advantage-point {
    max-width: 280px;
    gap: 20px;
    padding: 15px;
  }
  
  .point-icon {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }
  
  .point-title {
    font-size: 16px;
  }
  
  .point-list li {
    font-size: 13px;
  }
}

@media (max-width: 960px) {
  .factor-lifecycle-section {
    padding: 60px 20px;
  }
  
  .factor-cards-container {
    margin-bottom: 60px;
  }
  
  .factor-card {
    max-width: 500px;
    margin: 0 auto;
  }
  
  .advantages-diagram {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    min-height: auto;
    gap: 30px;
  }
  
  .diagram-core {
    grid-column: 1;
    grid-row: 1;
    width: 180px;
    height: 180px;
  }
  
  .core-title {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .core-strategy {
    font-size: 16px;
    margin: 6px 0;
  }
  
  .advantage-vertex {
    grid-column: 1;
  }
  
  /* 重新排序，使逻辑更清晰 */
  .theoretical-practice {
    grid-column: 1;
    grid-row: 2;
    justify-self: center;
    max-width: 400px;
  }
  
  .high-growth {
    grid-row: 3;
  }
  
  .multi-strategy {
    grid-column: 1;
    grid-row: 4;
    justify-self: center;
    max-width: 400px;
    align-self: center;
  }
  
  .high-liquidity {
    grid-row: 5;
  }
  
  .low-volatility {
    grid-row: 6;
  }
  
  .portfolio-diversification {
    grid-column: 1;
    grid-row: 7;
    justify-self: center;
    max-width: 400px;
    align-self: center;
  }
  
  .large-capacity {
    grid-row: 8;
  }
  
  .balanced-risk {
    grid-column: 1;
    grid-row: 9;
    justify-self: center;
    max-width: 400px;
  }
  
  .advantages-diagram::before {
    display: none;
  }
  
  /* 移动端优势点样式优化 */
  .advantage-point {
    max-width: 90%;
    gap: 15px;
    padding: 15px;
  }
  
  .point-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .point-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  
  .point-list li {
    font-size: 13px;
    margin-bottom: 8px;
  }
}

@media (max-width: 768px) {
  .factor-intro {
    font-size: 16px;
    margin-bottom: 40px;
  }
  
  .factor-cards-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .card-header {
    padding: 25px 25px 15px;
  }
  
  .card-content {
    padding: 25px;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
  
  .card-title {
    font-size: 20px;
  }
  
  .cycle-circle {
    width: 300px;
    height: 300px;
  }
  
  .cycle-step {
    width: 80px;
    height: 80px;
  }
  
  .step-number {
    width: 35px;
    height: 35px;
    font-size: 16px;
  }
  
  .step-name {
    font-size: 14px;
  }
  
  .strategy-advantages {
    padding: 60px 20px 80px;
  }
  
  .strategy-description {
    font-size: 16px;
    margin-bottom: 40px;
  }
  
  .cycle-section {
    padding: 40px 20px;
  }
  
  .cycle-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .cycle-content p {
    font-size: 14px;
    margin-bottom: 30px;
  }
}

@media (max-width: 520px) {
  .factor-cards-container {
    gap: 16px;
  }
  
  .card-header {
    padding: 20px 20px 12px;
    gap: 12px;
  }
  
  .card-content {
    padding: 20px;
  }
  
  .card-icon {
    width: 45px;
    height: 45px;
    font-size: 20px;
  }
  
  .card-title {
    font-size: 18px;
  }
  
  .card-desc {
    font-size: 14px;
  }
  
  .feature-item {
    font-size: 13px;
  }
  
  .cycle-circle {
    width: 250px;
    height: 250px;
  }
  
  .cycle-step {
    width: 70px;
    height: 70px;
  }
  
  .cycle-step.step-1,
  .cycle-step.step-2,
  .cycle-step.step-3,
  .cycle-step.step-4 {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    transform: none;
  }
  
  .cycle-step.step-1 {
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .cycle-step.step-2 {
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
  
  .cycle-step.step-3 {
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .cycle-step.step-4 {
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
  }
  
  .strategy-description {
    font-size: 14px;
    line-height: 1.7;
  }
  
  .advantages-diagram {
    gap: 30px;
  }
  
  .diagram-core {
    width: 180px;
    height: 180px;
  }
  
  .core-title {
    font-size: 12px;
  }
  
  .core-strategy {
    font-size: 14px;
  }
  
  .vertex-icon {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }
  
  .vertex-title {
    font-size: 14px;
  }
  
  .advantage-point {
    gap: 15px;
    padding: 12px;
  }
  
  .point-icon {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
  
  .point-title {
    font-size: 14px;
    margin-bottom: 10px;
  }
  
  .point-list li {
    font-size: 12px;
    margin-bottom: 8px;
  }
}
</style>